"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = void 0;
var _logger = require("../logger");
const handleError = (message = 'An error occurred', options, environmentOptions) => {
  switch (window.ENV) {
    case 'dev':
      if (environmentOptions?.throwInDev === false) {
        console.error(message);
        return;
      }
      throw new Error(message, options);
    case 'stage':
      {
        if (environmentOptions?.throwInStage === false) {
          console.error(message);
          (0, _logger.logError)(message);
          return;
        }
        const stageErr = Error(message, options);
        (0, _logger.logError)(message, {
          error: stageErr
        });
        throw stageErr;
      }
    case 'prod':
      console.error(message);
      (0, _logger.logError)(message);
      return;
    default:
      console.error(message);
      return;
  }
};
exports.handleError = handleError;